<!-- 审核中心页面 -->
<template>
    <div class="container">
        <div class="form">
            <el-form ref="formRef" :inline="true" label-width="90px" :model="{}">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="审核状态" prop="checkStatus">
                            <el-select v-model="form.auditStatus" clearable placeholder="请选择审核状态">
                                <template v-for="item in auditStatusList">
                                    <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="审核结果" prop="checkResult">
                            <el-select v-model="form.auditResult" clearable placeholder="请选择审核结果">
                                <template v-for="item in auditResultList">
                                    <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                                </template>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <div class="buttons">
                            <el-button type="primary" @click="queryList">查询</el-button>
                            <el-button @click="reSet">重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="list">
            <el-tabs v-model="activeKey">
                <el-tab-pane label="食谱知识库" />
                <el-tab-pane label="权威指南" />
                <el-tab-pane label="过敏源/饮食禁忌管理" />
            </el-tabs>
            <el-table :data="table" style="width: 100%">
                <el-table-column prop="serialNumber" align="center" label="序号">
                </el-table-column>
                <el-table-column prop="auditStatus" align="center" label="审核状态">
                    <template #default="{ row }">
                        <span>{{ auditStatusMap[row.auditStatus] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditResult" align="center" label="审核结果">
                    <div slot-scope="scope" class="tipsContainer">
                        <el-image v-if="scope.row.auditResult === '1'" :src="tipsOne"
                            @click="openReasonDialog(scope.row.rejectReason)" />
                        <span>{{ auditResultMap[scope.row.auditResult] || '-' }}</span>
                    </div>
                </el-table-column>
                <el-table-column prop="doctorName" align="center" label="医生名称">
                </el-table-column>
                <el-table-column prop="createTime" align="center" label="创建时间">
                </el-table-column>
                <el-table-column prop="contentName" align="center" label="审核内容">
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template #default="{ row }">
                        <div class="links">
                            <el-link type="primary" @click="toggleDialog(true, row.content, 'check')">查看详情</el-link>
                            <template v-if="row.auditResult === '1'">
                                <el-link v-if="row.operationType === '1' || row.operationType === '0'"
                                    @click="toggleDialog(true, row.content, 'edit', row.id)"
                                    type="primary">重新提交</el-link>
                                <el-link v-if="row.operationType === '2'" type="primary"
                                    @click="reDelete(row.content)">重新提交</el-link>
                            </template>
                            <el-link v-if="row.auditResult !== '0'" type="primary"
                            @click="revoke(row.id)">撤回</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <!-- 展示错误原因弹窗 -->
        <ShowReasonDialog :isOpen.sync="isShowDialog" :toggleReasonDialog="toggleReasonDialog" :reasonTxt="reasonTxt" />
        <!-- 展示食谱弹窗 -->
        <RecipeDialog v-if="isShowRecipeDialog" :closeDialog="toggleDialog" :operType="operType" :content="content"
            :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <el-button @click="toggleDialog">确 认</el-button>
            </div>
        </RecipeDialog>
        <!-- 展示权威指南弹窗 -->
        <AuthoritativeGuideDialog v-if="isShowAuthoritativeGuideDialog" :closeDialog="toggleDialog" :operType="operType"
            :content="content" :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <el-button @click="toggleDialog">确 认</el-button>
            </div>
        </AuthoritativeGuideDialog>
        <!-- 展示过敏源弹窗 -->
        <AvoidFoodDialog v-if="isShowAvoidFoodDialog" :closeDialog="toggleDialog" :operType="operType"
            :content="content" :rowId="rowId" @fetchTableList="fetchTableList">
            <div style="text-align: center;">
                <el-button @click="toggleDialog">确 认</el-button>
            </div>
        </AvoidFoodDialog>
    </div>
</template>
<script>
import { post } from '@/api/http';
import tipsOne from '@/assets/dietaryNutrition/tipsOne.png';
import ShowReasonDialog from './ShowReasonDialog.vue';
import RecipeDialog from './RecipeDialog.vue';
import AuthoritativeGuideDialog from './AuthoritativeGuideDialog.vue';
import AvoidFoodDialog from './AvoidFoodDialog.vue'
export default {
    name: "AuditCenter",
    components: { ShowReasonDialog, RecipeDialog, AuthoritativeGuideDialog, AvoidFoodDialog },
    created() {
        this.fetchTableList();
    },
    data() {
        return {
            form: {
                auditStatus: '',
                auditResult: ''
            },
            activeKey: "0", // tapkey
            table: [], // 表格数据
            pageNum: 1,
            pageSize: 10,
            total: 0,
            auditResultList: [ // 审核结果列表
                { dictKey: '0', dictValue: '通过' },
                { dictKey: '1', dictValue: '驳回' },
            ],
            auditResultMap: {
                '0': '通过',
                '1': '驳回'
            },
            auditStatusList: [ // 审核状态列表
                { dictKey: '0', dictValue: '已审核' },
                { dictKey: '1', dictValue: '待审核' },
            ],
            auditStatusMap: {
                '0': '已审核',
                '1': '待审核'
            },
            tipsOne, // 驳回提醒图片
            isShowDialog: false, // 展示错误原因弹窗
            reasonTxt: '', // 错误原因
            isShowRecipeDialog: false, // 展示食谱详情弹窗
            isShowAuthoritativeGuideDialog: false, // 展示权威指南详情弹窗
            isShowAvoidFoodDialog: false, // 展示过敏源详情弹窗
            content: '', // 弹窗内容
            operType: '', // 操作类别 check - 查看详情 edit - 重新提交
            rowId: '', // 行id
        }
    },
    watch: {
        activeKey() {
            this.pageNum = 1;
            this.fetchTableList();
        }
    },
    methods: {
        // 切换对话框显示状态
        toggleReasonDialog(isFlag = false) {
            this.isShowDialog = isFlag;
        },
        // 查询
        queryList() {
            this.pageNum = 1;
            this.fetchTableList();
        },
        // 查询表格列表
        async fetchTableList() {
            try {
                const params = {
                    module: this.activeKey,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                    userId: this.$store.state.user_info.userId,
                    ...this.form
                }
                const result = await post('diet/audit/pageAuditList', params);
                const {
                    data: { total = 0, list = [], pageNum = 1, pageSize = 10 } = {},
                } = result;
                this.table = list;
                this.total = total;
                this.pageNum = pageNum;
                this.pageSize = pageSize;
            } catch (error) {
                console.log(error);
            }
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.fetchTableList();
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.fetchTableList();
        },
        reSet() {
            this.form = {
                auditStatus: '',
                auditResult: ''
            }
            this.fetchTableList();
        },
        // 展示驳回原因
        openReasonDialog(reasonTxt = '') {
            this.reasonTxt = reasonTxt;
            this.toggleReasonDialog(true);
        },
        /**
         * 展示弹窗信息
         * @param flag 控制展示和隐藏
         * @param content 弹窗展示内容
         * @param operType 操作类别 check - 查看详情 edit - 重新提交
         * @param rowId 行id
         */
        toggleDialog(flag = false, content = '', operType = '', rowId = '') {
            this.content = content;
            this.operType = operType;
            this.rowId = rowId;
            switch (this.activeKey) {
                case '0':
                    this.isShowRecipeDialog = flag;
                    break;
                case '1':
                    this.isShowAuthoritativeGuideDialog = flag;
                    break;
                case '2':
                    this.isShowAvoidFoodDialog = flag;
                    break;
            }
        },
        // 重新提交-删除
        async reDelete(content) {
            let url = 'dish/delete'; // 食谱删除接口
            if (this.activeKey === '1') {
                url = 'guide/delete'; // 权威指南接口
            }
            const { id } = JSON.parse(content);
            try {
                const res = await this.$post(url, {
                    id,
                    userId: this.$store.state.user_info.userId
                });
                const { code } = res;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.fetchTableList();
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 撤回
        async revoke(id) {
            try {
                const res = await this.$post('diet/audit/revoke', {
                    id,
                });
                const { code } = res;
                if (code === "SUCCESS") {
                    this.$message.success("撤回成功");
                    this.fetchTableList();
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
}

</script>
<style scoped lang="scss">
.container {
    height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;

    .list {
        flex: 1;

        .add-button-class {
            width: 100px;
        }
    }
}

.buttons {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}


.tipsContainer {
    display: flex;
    justify-content: center;
    gap: 1px;
}
</style>